// eslint-disable-next-line import/no-unresolved
import brand from '@brand/brand.js';
import { zodResolver } from '@hookform/resolvers/zod';
import { FormProvider, useForm } from 'react-hook-form';
import { Trans, useTranslation } from 'react-i18next';
import * as z from 'zod';
import { BrandedLayout } from '../components/layouts/branded-layout';
import { SubmitButton } from '../components/submit-button';
import { InfoBlock } from '../components/ui/info-block';
import { Input } from '../components/ui/input';
import { useInviteSummary } from '../store/use-invite-store';
import { cleanPhone } from '../utils/phone';

const resolver = zodResolver(
  z.object({
    bookingReference: z.preprocess(
      (x) => x?.replaceAll(/\s+/g, '').toLowerCase() ?? '',
      z
        .string()
        .min(1)
        .regex(/^[a-z0-9]{6}$/),
    ),
  }),
);

export function EnterInvite() {
  const invite = useInviteSummary();
  const { t } = useTranslation('page.enter-invite');
  const form = useForm({
    defaultValues: { bookingReference: invite?.reference },
    resolver,
    mode: 'onChange',
  });

  const onSubmit = ({ bookingReference }) => {
    window.location = `/${bookingReference}`;
  };

  return (
    <BrandedLayout>
      <div className="mb-5">
        <h1 className="title font-medium mb-5">
          <Trans
            i18nKey="title"
            ns="page.welcome"
            components={{ strong: <strong className="block" /> }}
            values={brand}
          />
        </h1>
        <h2 className="title font-medium">{t('title')}</h2>
        <Trans i18nKey="text" ns="page.enter-invite" components={{ p: <p /> }} />
      </div>

      <FormProvider {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)} className="pt-2.5 space-y-4">
          <Input name="bookingReference" label={t('code')} className="uppercase" autoFocus />
          <SubmitButton />
        </form>
      </FormProvider>

      <InfoBlock>
        <Trans
          i18nKey="helpMessage"
          ns="page.enter-invite"
          values={{ phone: brand.phone }}
          components={{
            p: <p />,
            br: <br />,
            strong: <strong className="font-semibold" />,
            a: <a href={`tel:${cleanPhone(brand.phone)}`} />,
          }}
        />
      </InfoBlock>
    </BrandedLayout>
  );
}
